import styled from "styled-components";
import { FONT_WT_LIGHT } from "@website-builder/utilities-index";
import("../../styles/prism.css");

export const BlogContentWrappper = styled.div`
	a,
	a:visited,
	a:active,
	a:hover {
		font-weight: ${FONT_WT_LIGHT};
		color: inherit;
	}
`;
